import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';

const StreamPlayer = ({ user }) => {
  const [transmisionActiva, setTransmisionActiva] = useState(false);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const verificarEstadoTransmision = async () => {
      try {
        const { data, error } = await supabase
          .from('configuracion')
          .select('transmision_activa')
          .eq('id', 1)
          .maybeSingle();
        
        if (error) throw error;
        if (data !== null) setTransmisionActiva(data.transmision_activa);
      } catch (err) {
        console.error("Error en polling:", err.message);
      } finally {
        setCargando(false);
      }
    };

    verificarEstadoTransmision();
    const intervalo = setInterval(verificarEstadoTransmision, 5000);
    return () => clearInterval(intervalo);
  }, []);

  if (cargando) return <div className="min-h-screen bg-zinc-950 flex items-center justify-center text-white"><p className="animate-pulse">Sincronizando...</p></div>;

  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      {/* Encabezado restaurado */}
      <header className="p-6 bg-zinc-900 flex justify-between items-center border-b border-zinc-800">
        <h2 className="font-black text-xl">EMACT <span className="text-blue-500">KIDS</span></h2>
        <span className="text-[10px] font-bold text-zinc-500 border border-zinc-700 px-3 py-1 rounded-full">
          TEL: {user.telefono}
        </span>
      </header>

      <main className="max-w-4xl mx-auto p-6">
        {transmisionActiva ? (
          <div className="aspect-video bg-black rounded-3xl overflow-hidden border-4 border-zinc-800">
            <iframe 
              // 👇 ENLACE DE LA OPCIÓN 2 APLICADO AQUÍ
              src="https://camara.emacttech.online" 
              title="Camara"
              width="100%" 
              height="100%"
              allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
              sandbox="allow-scripts allow-same-origin allow-forms"
              style={{ border: 'none' }}
            />
          </div>
        ) : (
          <div className="aspect-video bg-zinc-900 rounded-3xl flex flex-col items-center justify-center border-4 border-dashed border-zinc-800">
            <span className="text-4xl mb-2">🔒</span>
            <p>Transmisión Cerrada</p>
          </div>
        )}
      </main>
    </div>
  );
};

export default StreamPlayer;
